import { LayoutGrid, Grid3X3 } from 'lucide-react';

export function TileSizeSlider({ tileSize, setTileSize, min, max }) {
  return (
    <div className="hidden sm:flex items-center gap-2">
      <Grid3X3 className="w-4 h-4 text-[var(--theme-text-muted)] flex-shrink-0" />
      <input
        type="range"
        min={min}
        max={max}
        step={10}
        value={tileSize}
        onChange={(e) => setTileSize(Number(e.target.value))}
        className="w-20 sm:w-24 h-1 accent-[#1E3A5F] cursor-pointer"
        aria-label="Tile size"
      />
      <LayoutGrid className="w-4 h-4 text-[var(--theme-text-muted)] flex-shrink-0" />
    </div>
  );
}
